/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = require('./$.export');

$export($export.P, 'Map', {toJSON: require('./$.collection-to-json')('Map')});



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/es7.map.to-json.js
 ** module id = 1354
 ** module chunks = 0
 **/